module.exports = {
    "baseUrl": "https://api-v4.iris-health.com",
    "baseUrl2": "",
    "dashboardUrl": "",
    "systemName": "System Prod",
    "newChatServer": "https://chat.iris-health.com",
    "prodStatus": false,
    "patientChatUrl": "https://patientchat.iris-health.com",
    "stripeKey": "pk_live_51Ia02yIg43ZjHHGkZRwf5Ap3qTBlvEKJIe08edJWqyVDlEs30E8wHlnWl8XWqfzlEufmqMwattqTzzojGlDc6Sul00stDc8rJm",
    "companyTitle": "Clinic Scheduler | Iris Health",
    "metaTitle": "Iris Health Scheduler Web App",
    "metaDescription": "Scheduler for physicians and clinics from Iris Health",
    "favicon": "%PUBLIC_URL%/iris-health-logo.jpeg",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris",
    "aboutHref": "https://www.iris-health.com/about/",
    "contactHref": "https://www.iris-health.com/contact-us/",
    "selfPayApi": "https://app.iris-health.com"
}